<!-- <div *ngIf="roleArray.includes(user_role)"  class="row m-4"> -->
<div class="row">

  <div class="col-12 align-self-center">
    <h2 class="page-title">VMS Dashboard</h2>
    <ul class="nav nav-tabs" style="margin-top: 10px;">
      <li class="nav-item"><a (click)="refetchData()"
        class="nav-link active" style="cursor: pointer;background-color: gainsboro;" >Refresh Graphs</a></li>
      <hr>
    </ul>
  </div>

  <div class="col-md-8">
    
    <status-units-graph></status-units-graph>
  </div>
  <div class="col-md-4">
    <app-provisioned-units-graph></app-provisioned-units-graph>
  </div>

  <div class="col-md-8">
    <app-total-units-added-date-graph></app-total-units-added-date-graph>
  </div>
  <div class="col-md-4">
    <app-monitored-units-graph></app-monitored-units-graph>
  </div>

  <div class="col-md-12" *ngIf="adminAuthorization">
    <quick-action-tabs></quick-action-tabs>
  </div>

<!-- </div> -->
<!--
<div class="container-fluid mt-md-3">


  <hr>
  <iframe class="shadow"  style="width:90vw;height:70vh;border-width: 0px;border-color:white"></iframe>

</div>
<div class="container-fluid mt-md-3">

   <h1>Health check - 1 hour - </h1>
  <hr>
<iframe class="shadow" style="width:90vw;height:70vh;border-width: 0px;border-color:white"></iframe>
</div>
</div> -->
